module.exports = __webpack_public_path__ + "static/media/Pittogramma-badante.a444e9c1.png";